import { render, staticRenderFns } from "./orgManage.vue?vue&type=template&id=5f33c428&scoped=true"
import script from "./orgManage.vue?vue&type=script&lang=js"
export * from "./orgManage.vue?vue&type=script&lang=js"
import style0 from "./orgManage.vue?vue&type=style&index=0&id=5f33c428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f33c428",
  null
  
)

export default component.exports